import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { configurationRoute } from './configuration/configuration.route';
import { mailTemplateContainerRoute } from './configuration/mailTemplateContainer.route';
import { profilesContainerRoute } from './configuration/profilesContainer.route';
import { settingsContainerRoute } from './configuration/settingsContainer.route';
import { sportsRoute } from './configuration/sports.route';
import { termsContainerRoute } from './configuration/termsContainer.route';
// Do przywrócenia w przyszłości
// import { roleContainerRoute } from './configuration/roleContainer.route';

export const configurationContainerRoute: RouteConfig = {
  path: '/configuration',
  component: RouterView,
  children: [
    configurationRoute,
    profilesContainerRoute,
    settingsContainerRoute,
    sportsRoute,
    mailTemplateContainerRoute,
    termsContainerRoute
  ],
  redirect: { name: 'configuration' },
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.configuration.index',
      name: 'configuration'
    }
  }
};
